import React, { useEffect, useState } from 'react';
import api from '../services/api';
import logo from '../assets/FCI Logo - Cropped.png';
import '../css/requisition-app-styles.css';
import { Link } from 'react-router-dom';
import userIcon from '../img/User-Icon.png';
import TopBarIcons from './TopBarIcons';
import axios from 'axios';
import { useLocation, useNavigate } from "react-router-dom";
import "../css/Requisitions.css";
import Sidebar from './Sidebar';
import { jwtDecode } from 'jwt-decode';



const Approved = () => {
  const navigate = useNavigate();
  const location = useLocation(); 
  const [requisitions, setRequisitions] = useState([]);
  const theUserType = localStorage.getItem('userType');
  const [error, setError] = useState(null);
  const [activeTab, setActiveTab] = useState(location.state?.defaultTab || 'Approved'); 
  const storedFullName = localStorage.getItem('fullName');
  const [reviewers, setReviewers] = useState([]);
  const theUserId = localStorage.getItem('userId');
  const [reviewerNumber, setReviewerNumber] = useState(null);

  const handleView = (requisitionID) => {
      navigate(`/view-requisition/${requisitionID}`);
  };

  const handleSurrender = (requisitionID) => {
    navigate(`/surrender/${requisitionID}`);
};

  

const fetchRequisitionsByStatus = async (status) => {
  try {
    const token = localStorage.getItem("token");
    const response = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/Requisition/status`, {
        params: { status },
    });

    const data = Array.isArray(response.data)
      ? response.data
      : response.data.$values ?? [];

    setRequisitions(data);
    setError(null);
  } catch (err) {
    console.error(err);
    if (err.response?.status === 404) {
      setError(`No requisitions found for status: ${status}.`);
    } else if (err.response?.status === 401) {
      setError("You must be logged in to view your requisitions.");
    } else {
      setError("Error fetching requisitions.");
    }
    setRequisitions([]);
  }
};



useEffect(() => {
    fetchRequisitionsByStatus(activeTab);
}, [activeTab]); 


const handleTabClick = (tab) => {
    setActiveTab(tab);
    console.log("Full name", storedFullName);
};

useEffect(() => {
    const fetchReviewers = async () => {
      try {
        const response = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/users/reviewers`);
        const data = response.data;
  
        if (!Array.isArray(data.$values)) {
          console.error("Unexpected response format:", data);
          setReviewers([]);
          return;
        }
  
        const allReviewers = data.$values.map(r => ({
          ...r,
          id: String(r.id)
        }));
        setReviewers(allReviewers);
  
        if (!theUserId) return;
  
        const current = allReviewers.find(r => r.id === String(theUserId));
        if (!current) return;
  
        const currentNum = current.reviewerNumber;
        setReviewerNumber(currentNum);
  
        
      } catch (error) {
        console.error("Error fetching reviewers:", error);
        setReviewers([]);
      }
    };
  
    fetchReviewers();
  }, [theUserId]);
  

useEffect(() => {

    const token = localStorage.getItem('token');
    if (!token) return;
  
    const decoded = jwtDecode(token); 
    setReviewerNumber(decoded.reviewerNumber || null); 
    console.log("Reviewer number", reviewerNumber);
  }, []);
  

const getStatusClass = (status) => {
    if (status === "Draft") return "status-draft"; 
    if (status === "Submitted") return "status-submitted";
    if (status === "Surrender Submitted") return "status-surrender-submitted";
    if (status.startsWith("Reviewed by")) return "status-reviewed";
    if (status === "Approved") return "status-approved";
    if (status === "Surrender Approved") return "status-surrender-approved";
    if (status === "Disapproved") return "status-disapproved"; 
    
    return ""; 
  };

      
    return (
        <div id="wrapper">
          
          <Sidebar userType={theUserType} />


{/* Content Wrapper */}

<div id="content-wrapper" className="d-flex flex-column">

    {/* Main Content */}
    <div id="content">



    {/* Topbar */}
    <nav className="navbar navbar-expand navbar-light bg-white topbar mb-4 static-top shadow">

    {/* Sidebar Toggle*/}
    <button id="sidebarToggleTop" className="btn btn-link d-md-none rounded-circle mr-3">
        <i className="fa fa-bars"></i>
    </button>

    {/* Topbar Search */}
    <form className="d-none d-sm-inline-block form-inline mr-auto ml-md-3 my-2 my-md-0 mw-100 navbar-search">
        <div className="input-group">
            <input type="text" className="form-control bg-light border-0 small" placeholder="Search"
                aria-label="Search" aria-describedby="basic-addon2" />
            <div className="input-group-append">
                <button className="btn btn-primary" type="button">
                    <i className="fas fa-search fa-sm"></i>
                </button>
            </div>
        </div>
    </form>

    {/* Topbar Navbar */}
    <ul className="navbar-nav ml-auto">

        <TopBarIcons />
        
        

    </ul>

    </nav>
    {/* End of Topbar */}






        {/* Begin Page Content */}
        <div className="container-fluid">
        {(reviewerNumber === 1 || reviewerNumber === 2) && (
        <div>
            <h1 className="h3"> Everyones Requisitions</h1>
            <br/>
        </div>
        )}
        {reviewerNumber === 3 && (
        <div>
            <h1 className="h3"> Approved</h1>
            <br/>
        </div>
        )}
            {/* Tabs */}
            <div className="tabs">
             {(reviewerNumber === 1 || reviewerNumber === 2) && (
                <button
                    className={`nav-link ${activeTab === 'Submitted' ? 'active' : ''}`}
                    onClick={() => handleTabClick('Submitted')}
                >
                   All Submitted
                </button>
                 )}
                {(reviewerNumber === 2 || reviewerNumber === 3) && (
                <button
                className={`nav-link ${activeTab === `Approved` ? 'active' : ''}`}
                onClick={() => handleTabClick(`Approved`)}
                >
                Approved
                </button>
            )}
            
            </div>


            

            <div id="requsition-table">
                <table className="table req-table-bordered">
                    <thead>
                        <tr>
                            <th className="req-th">Activity Start Date</th>
                            <th className="req-th">Activity Name</th>
                            <th className="req-th">Activity Purpose</th>
                            <th className="req-th">District and AP</th>
                            <th className="req-th">Status</th>
                            <th className="req-th">Actions</th>
                        </tr>
                    </thead>
                    <tbody>
                    {requisitions
                        .slice()
                        .sort((a, b) => new Date(b.requisitionDate) - new Date(a.requisitionDate))
                        .map((requisition) => {
                            const date = new Date(requisition.from);
                            const day = date.getDate();
                            const month = date.toLocaleString("en-US", { month: "long" });
                            const year = date.getFullYear();
                            
                            return (
                                <tr key={requisition.requisitionID}>
                                    <td>{`${day} ${month} ${year}`}</td>
                                    <td>{requisition.activityName}</td>
                                    <td>{requisition.activityPurpose}</td>
                                    <td>
                                {requisition.districtAndAreaProgramPairs?.$values?.length > 0
                                    ? `${requisition.districtAndAreaProgramPairs.$values[0].district} - ${requisition.districtAndAreaProgramPairs.$values[0].areaProgram}`
                                    : "N/A"}
                                </td>
                                <td>
                                    <div className={getStatusClass(requisition.status)}>
                                    {requisition.status}
                                    </div>
                                </td>
                                <td>
                                  <div className="button-container">
                                      <Link className="nav-link" to={`/review-requisition/${requisition.requisitionID}`}>
                                          <div className="view-button btn btn-sm" onClick={() => handleView(requisition.requisitionID)}>
                                              <i className="fas fa-file-alt button-icon"></i>
                                              <span>Review</span>
                                          </div>
                                      </Link>
                                  </div>
                              </td>

                            </tr>
                            ); 
                          })}
                    </tbody>
                </table>
            </div>





        </div>
        {/* End of container-fluid */}

    </div>
    {/* End of Main Content */}

    {/* Footer */}
    <footer className="sticky-footer bg-white">
        <div className="container my-auto">
            <div className="copyright text-center my-auto">
                <span>Copyright &copy; Farm Concern International 2025 </span>
            </div>
        </div>
    </footer>
    {/* End of Footer */}

</div>


    
    {/* End of Content Wrapper */}


           
          
          
        </div>

  );
   
};

export default Approved;